

export const ServiceWorkerError = {
    noError:                                'noError',
    serviceWorkersNotSupported:             'serviceWorkersNotSupported',
    serviceWorkerRegisterationFailed:       'serviceWorkerRegisterationFailed'
};

export class ServiceWorkerTool   {

    register(path, options) {

        if('serviceWorker' in navigator)    {
            return navigator.serviceWorker.register(path, options).then((registration) => {
                console.log('Service worker registration successful:', registration);
                return registration;
            }, (error) => {
                console.error(`Error - could not create service worker - service worker registration failed: ${error}`);
                return new Error(ServiceWorkerError.serviceWorkerRegisterationFailed, {cause: error});
            });
        }

        console.error('Error - could not create service worker - service workers are not supported.');
        return Promise.reject(new Error(ServiceWorkerError.serviceWorkersNotSupported));
    }

    isReady()   {
        if('serviceWorker' in navigator)    {
             return navigator.serviceWorker.ready;            // gets never rejected (specification)
        }
        return false;
    }

    getActive() {
        if('serviceWorker' in navigator)    {
             return navigator.serviceWorker.ready.then(registration => registration.active);            // gets never rejected (specification)
        }
        return Promise.reject(new Error(ServiceWorkerError.serviceWorkersNotSupported));
    }

    postMessageR(message, onProgress)    {
        return this.getActive().then(active => {
            return new Promise((resolve, reject) => {
                
                let messageChannel = new MessageChannel();
                messageChannel.port1.onmessage = event => {

                    if(Array.isArray(event.data))   {
                        let type = event.data[0];
                        if(type === 'progress') {
                            if(onProgress)  onProgress({value: event.data[1], count: event.data[2]});
                            return;
                        }
                        resolve(event.data[1]);
                        return;
                    }

                    resolve(event.data);
                };

                active.postMessage(message, [messageChannel.port2]);
            });
        });
    }

    postMessage(message)    {
        return this.getActive().then(active => {
            active.postMessage(message);
        });
    }

    registerMessageListener(listener)  {
        if('serviceWorker' in navigator)    {
            navigator.serviceWorker.addEventListener('message', listener);
        }
        
    }

    unregisterMessageListener(listener) {
        if('serviceWorker' in navigator)    {
            navigator.serviceWorker.removeEventListener('message', listener);
        }
    }
};

export default new ServiceWorkerTool();